import { render, staticRenderFns } from "./UsersTotalCountCard.vue?vue&type=template&id=4ba22dfd&"
import script from "./UsersTotalCountCard.vue?vue&type=script&lang=js&"
export * from "./UsersTotalCountCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports